import components from "./components.json";
import views from "./views.json";

export const fi = {
  components,
  views,
};
